export default "__VITE_ASSET__1e36d913__"